// extracted by mini-css-extract-plugin
export default {"root":"LinkButton_root__2Vx2I","disabled":"LinkButton_disabled__L+gsb"};